module.exports = __webpack_public_path__ + "static/media/np.27f0f4e7.svg";